type Props = {
  src: string
  className?: string
  alt?: string
  children?: React.ReactNode
}

const Img = ({ src, className, alt }: Props) => {
  if (alt === undefined) {
    // If no alt is provided, use the filename
    alt = src
      .replace(/^.*[\\/]/, '')
      .split('.')
      .slice(0, -1)
      .join('.')
  }
  return <img className={className} src={src} alt={alt} />
}

export default Img
